// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `minutes`
};

const de_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `Minuten`
};

const es_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `minutos`
};

const fr_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `minutes`
};

const fi_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `minuuttia`
};

const hi_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `मिनट`
};

const ja_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `分`
};

const nl_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `minuten`
};

const pt_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `minutos`
};

const ro_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `minute`
};

const th_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `นาที`
};

const ur_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `منٹ`
};

const zh_hant1_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `分鐘`
};

const da_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `minutter`
};

const it_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `minuti`
};

const vn_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `phút`
};

const ko_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `분`
};

const tr_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `dakika`
};

const lv_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `minūtes`
};

const ar_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `دقائق`
};

const bs_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `minuta`
};

const sl_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `minute`
};

const id_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `menit`
};

const sv_widget_time_minutes = /** @type {(inputs: {}) => string} */ () => {
	return `minuter`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_time_minutes = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_time_minutes(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_time_minutes", locale)
	if (locale === "en") return en_widget_time_minutes(inputs)
	if (locale === "de") return de_widget_time_minutes(inputs)
	if (locale === "es") return es_widget_time_minutes(inputs)
	if (locale === "fr") return fr_widget_time_minutes(inputs)
	if (locale === "fi") return fi_widget_time_minutes(inputs)
	if (locale === "hi") return hi_widget_time_minutes(inputs)
	if (locale === "ja") return ja_widget_time_minutes(inputs)
	if (locale === "nl") return nl_widget_time_minutes(inputs)
	if (locale === "pt") return pt_widget_time_minutes(inputs)
	if (locale === "ro") return ro_widget_time_minutes(inputs)
	if (locale === "th") return th_widget_time_minutes(inputs)
	if (locale === "ur") return ur_widget_time_minutes(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_time_minutes(inputs)
	if (locale === "da") return da_widget_time_minutes(inputs)
	if (locale === "it") return it_widget_time_minutes(inputs)
	if (locale === "vn") return vn_widget_time_minutes(inputs)
	if (locale === "ko") return ko_widget_time_minutes(inputs)
	if (locale === "tr") return tr_widget_time_minutes(inputs)
	if (locale === "lv") return lv_widget_time_minutes(inputs)
	if (locale === "ar") return ar_widget_time_minutes(inputs)
	if (locale === "bs") return bs_widget_time_minutes(inputs)
	if (locale === "sl") return sl_widget_time_minutes(inputs)
	if (locale === "id") return id_widget_time_minutes(inputs)
	if (locale === "sv") return sv_widget_time_minutes(inputs)
	return "widget_time_minutes"
};